import React from 'react'
import { Button, Confirm, Dropdown, Header, Form, Icon, Tab } from 'semantic-ui-react'
import Details from './article/details'
import Images from './article/images'
import { inlineStyle } from '../../styles/custom'
import { languages } from '../../constants'
import PermissionsManager from '../PermissionsManager'

const defaultType = 'internal'

const renderPanes = (obj, onChange, status) => {
  let panes = languages.map((language) => {
    const attrs = {obj: obj, language: language, onChange: onChange, status: status, defaultType}
    return {menuItem: language.label, render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>}
  })

  panes.push({menuItem: 'Gestion des images', render: () => <Tab.Pane attached={false}><Images obj={obj} onChange={onChange} defaultType={defaultType} /></Tab.Pane>})

  return panes
}

const renderCategories = (categories) => {
  if (categories === undefined) return null

  let _categories = [{ value: null, text: '--' }]
  categories.forEach(category => {
    _categories.push({value: category.id, text: category.details[0].label})
  })
  return _categories
}

const renderAuthors = (authors) => {
  if (authors === undefined) return null

  let _authors = [{ value: null, text: '--' }]
  authors.forEach(author => {
    _authors.push({value: author.id, text: author.name})
  })
  return _authors
}

const renderTypes = () => {
  const types = [
    { value: 'internal', text: 'Article interne' },
    { value: 'external', text: 'Article externe' }
  ]

  return types
}

const ArticleForm = ({ obj, status, categories, authors, onChange, onSubmit, onDelete }) => {
  let article_date
  if (obj.article_date === null) {
    const d = new Date()
    let month = String(d.getMonth() + 1)
    let day = String(d.getDate())
    const year = String(d.getFullYear())
    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    article_date = `${month}-${day}-${year}`
  } else {
    article_date = obj.article_date.replace(/\//g, '-')
  }

  return (
    <Form>
      <Header>Article : {status.isNew ? 'Création' : 'Édition'}</Header>
      <Form.Field>
        <label>Type d'article</label>
        <Dropdown
          placeholder="Sélectionnez un type d'article"
          fluid
          selection
          closeOnChange
          id='type'
          value={(obj.type) ? obj.type : defaultType}
          options={renderTypes()}
          onChange={(e, data) => onChange(e, data, 'dropdown')}
        />
      </Form.Field>
      <Form.Field>
        <label>Catégorie</label>
        {
          categories.loading && !obj.category_id ? <div>Chargement des catégories</div> :
            <Dropdown placeholder='Sélectionnez une catégorie' fluid selection closeOnChange id='category_id' value={obj.category_id} options={renderCategories(categories.getCategories)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        }
      </Form.Field>
      { obj.type && defaultType === obj.type &&
        <Form.Field>
          <label>Auteur</label>
          {
            authors.loading && !obj.author_id ? <div>Chargement des auteurs</div> :
              <Dropdown placeholder='Sélectionnez un auteur' fluid selection closeOnChange id='author_id' value={obj.author_id} options={renderAuthors(authors.getAuthors)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
          }
        </Form.Field>
      }
      <Form.Field id='article_date' label="Date (tri chronologique)" control='input' type='date' onChange={(e, data) => {onChange(e, data)}} value={article_date} />
      { obj.type && defaultType !== obj.type &&
        <Form.Field id='link' label="Lien externe" placeholder="Lien externe (http://...)" control='input' onChange={(e, data) => {onChange(e, data)}} value={obj.link} />
      }
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange, status)} />
      <br /><br />
      <Form.Field>
        <PermissionsManager hasPermissions={['create_article', 'update_article']}>
          {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
            <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
          }
        </PermissionsManager>
        <PermissionsManager hasPermissions={['delete_article']}>
          {!status.isNew ? (
            <div>
              <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
            </div>
          ) : null}
        </PermissionsManager>
      </Form.Field>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer cet article ? Cette action est définitive.'
        open={status.deletion.confirm} onCancel={(event, data) => { onDelete(event, { confirm: null }) }}
        onConfirm={(event, data) => { onDelete(event, { confirm: false }) }} style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default ArticleForm



// WEBPACK FOOTER //
// ./src/components/form/Article.js